module.exports = __webpack_public_path__ + "static/img/FR.24fd396f.svg";